export default {
  title: "المستخدمون",
  subtitle: "إدارة حسابات المستخدمين",
  banCustomer: "حظر المستخدم",
  activateCustomer: "تفعيل المستخدم",
  
  addNew: "إضافة مستخدم جديد",
  createUser: "إنشاء مستخدم",
  editUser: "تعديل المستخدم",
  deleteUser: "حذف المستخدم",
  
  fields: {
    name: "الاسم",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    role: "الوظيفة",
    department: "القسم",
    position: "المنصب",
    avatar: "الصورة الشخصية",
    isActive: "نشط",
    isVerified: "مُتحقق",
    lastLogin: "آخر تسجيل دخول",
    loginCount: "عدد مرات تسجيل الدخول",
    status: "الحالة",
    notes: "ملاحظات",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث"
  },
  
  placeholders: {
    firstName: "أدخل الاسم الأول",
    lastName: "أدخل الاسم الأخير",
    email: "أدخل البريد الإلكتروني",
    phone: "أدخل رقم الهاتف",
    username: "أدخل اسم المستخدم",
    password: "أدخل كلمة المرور",
    confirmPassword: "أكد كلمة المرور",
    department: "أدخل القسم",
    position: "أدخل المنصب",
    notes: "أدخل ملاحظات إضافية",
    name: "الاسم",
    role: "الوظيفة"
  },
  
  messages: {
    createSuccess: "تم إنشاء المستخدم بنجاح",
    createError: "فشل في إنشاء المستخدم",
    updateSuccess: "تم تحديث المستخدم بنجاح",
    updateError: "فشل في تحديث المستخدم",
    deleteSuccess: "تم حذف المستخدم بنجاح",
    deleteError: "فشل في حذف المستخدم",
    deleteConfirm: "هل أنت متأكد من حذف هذا المستخدم؟",
    statusConfirm: "هل أنت متأكد من {{action}} هذا المستخدم؟",
    statusSuccess: "تم {{action}} المستخدم بنجاح",
    statusError: "فشل في تحديث حالة المستخدم",
    resetPasswordConfirm: "هل أنت متأكد من إعادة تعيين كلمة مرور هذا المستخدم؟",
    noUsers: "لا يوجد مستخدمون",
    loadingUsers: "جاري تحميل المستخدمين...",
    fetchError: "فشل في جلب المستخدمين",
    passwordResetSuccess: "تم إرسال بريد إعادة تعيين كلمة المرور",
    passwordResetError: "فشل في إرسال بريد إعادة تعيين كلمة المرور"
  },
  
  validation: {
    firstNameRequired: "الاسم الأول مطلوب",
    lastNameRequired: "الاسم الأخير مطلوب",
    nameRequired: "الاسم مطلوب",
    nameMinLength: "الاسم يجب أن يكون حرفين على الأقل",
    emailRequired: "البريد الإلكتروني مطلوب",
    emailFormat: "يرجى إدخال بريد إلكتروني صحيح",
    emailInvalid: "يرجى إدخال بريد إلكتروني صحيح",
    emailExists: "البريد الإلكتروني موجود بالفعل",
    usernameRequired: "اسم المستخدم مطلوب",
    usernameMinLength: "اسم المستخدم يجب أن يكون 3 أحرف على الأقل",
    usernameExists: "اسم المستخدم موجود بالفعل",
    passwordRequired: "كلمة المرور مطلوبة",
    passwordMinLength: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
    passwordComplexity: "يجب أن تحتوي كلمة المرور على حرف كبير وحرف صغير ورقم ورمز خاص",
    passwordTooEasy: "لا يمكن أن تكون كلمة المرور سهلة مثل 123456",
    passwordMatchesPhone: "لا يمكن أن تطابق كلمة المرور رقم الهاتف المحمول المسجل",
    passwordMatch: "كلمات المرور غير متطابقة",
    phoneRequired: "رقم الهاتف مطلوب",
    phoneFormat: "يرجى إدخال رقم هاتف صحيح",
    roleRequired: "الوظيفة مطلوبة",
    fillAllFields: "يرجى ملء جميع الحقول المطلوبة"
  },
  
  table: {
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    username: "اسم المستخدم",
    role: "الوظيفة",
    department: "القسم",
    lastLogin: "آخر تسجيل دخول",
    status: "الحالة",
    actions: "خيارات الأوامر"
  },
  
  statusOptions: {
    active: "نشط",
    inactive: "غير نشط",
    suspended: "معلق",
    banned: "محظور",
    pending: "في الانتظار"
  },
  
  actions: {
    resetPassword: "إعادة تعيين كلمة المرور",
    sendVerification: "إرسال التحقق",
    activate: "تفعيل",
    deactivate: "إلغاء التفعيل",
    suspend: "تعليق"
  },
  
  breadcrumbs: {
    users: "المستخدمون",
    create: "إنشاء مستخدم",
    edit: "تعديل المستخدم",
    view: "عرض المستخدم",
    profile: "الملف الشخصي"
  },

  buttons: {
    submit: "إرسال",
    update: "تحديث",
    submitting: "جاري الإرسال...",
    updating: "جاري التحديث...",
    backToIndex: "العودة للقائمة"
  },

  viewLogs: "عرض السجلات",

  logs: {
    title: "سجلات المستخدم",
    subtitle: "سجلات النشاط للمستخدم #{{userId}}",
    timestamp: "الوقت",
    level: "المستوى",
    message: "الرسالة",
    requestUrl: "رابط الطلب",
    exception: "استثناء",
    noLogs: "لا توجد سجلات لهذا المستخدم",
    fetchLogsError: "فشل في جلب سجلات المستخدم"
  }
};
